import React from 'react';
import ReactDOM from 'react-dom';
import './globals/Default.scss'
import './globals/RangeInput.css'

import RootRouter from './content/RootRouter';
import Amplify from 'aws-amplify';
import config from './config'
Amplify.configure(config);


ReactDOM.render(
  <React.StrictMode>
    <RootRouter />
  </React.StrictMode>,
  document.getElementById('root'),
);
